
import { API_DEMO_CATALGUE, API_DEMO_CATALOGUE_DETAILS } from '../../../Constants/apiUrls';
import {
    FETCH_DEMO_CATALOG_REQUEST,
    FETCH_DEMO_CATALOG_SUCCESS,
    FETCH_DEMO_CATALOG_FAILURE,
    FETCH_NARRATIVE_DETAILS_REQUEST,
    FETCH_NARRATIVE_DETAILS_SUCCESS,
    FETCH_NARRATIVE_DETAILS_FAILURE
} from '../../../Constants/actionTypes';

import { fetchDemoCatalgue } from '../../../Constants/apiService'




// Fetch Demo Catalog Thunk
export const fetchDemoCatalog = () => {
    return async (dispatch, getState) => {
        dispatch({ type: FETCH_DEMO_CATALOG_REQUEST });

        // Retrieve access token from the state
        const state = getState();
        const accessToken = state.auth.accessToken;
        try {
            const data = await fetchDemoCatalgue(accessToken);
            dispatch({ type: FETCH_DEMO_CATALOG_SUCCESS, payload: data });
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch({ type: FETCH_DEMO_CATALOG_FAILURE, payload: error.message });
        }
    };
};




// Fetch Narrative Details Thunk
export const fetchNarrativeDetails = (id) => {
    return async (dispatch, getState) => {
        dispatch({ type: FETCH_NARRATIVE_DETAILS_REQUEST });

        // Retrieve access token from the state
        const state = getState();
        const accessToken = state.auth.accessToken;

        try {
            const response = await fetch(API_DEMO_CATALOGUE_DETAILS(id), {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            const data = await response.json();
            dispatch({ type: FETCH_NARRATIVE_DETAILS_SUCCESS, payload: data });
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch({ type: FETCH_NARRATIVE_DETAILS_FAILURE, payload: errorMessage });
        }
    };
};





